import { Platform } from "react-native";
import Animated, {
  useAnimatedKeyboard,
  useAnimatedStyle,
} from "react-native-reanimated";

export function KeyboardBottomInset() {
  if (Platform.OS === "ios") {
    return <IOSBottom />;
  }
  return null;
}

function IOSBottom() {
  const f = useAnimatedKeyboard();

  const style = useAnimatedStyle(() => {
    return {
      width: "100%",
      height: f.height.value,
    };
  });

  return <Animated.View style={style} />;
}
